import { useState } from 'react';
import { Button } from '../../../components/ui/button';

// Stage 7A D2.16 — prompt for the new draft name, prefilled "<source> (copy)".
// Submitting clones any source (draft or published) into a fresh editable draft.
// Shared by the drafts list (per-row Duplicate) and the compose page (published
// "Duplicate as new").
export function DuplicateModal({
  sourceTitle,
  busy,
  onCancel,
  onConfirm,
}: {
  sourceTitle: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: (newTitle: string) => void;
}) {
  const [title, setTitle] = useState(`${sourceTitle} (copy)`);
  const submit = () => {
    const t = title.trim();
    if (t !== '') onConfirm(t);
  };
  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center bg-black/30 p-4" onClick={onCancel}>
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-base font-semibold text-slate-800">Duplicate draft</h3>
        <p className="mt-2 text-sm text-slate-600">
          Creates a new editable draft with the same targeting, creative, and settings.
        </p>
        <label htmlFor="dup-title" className="mb-1.5 mt-4 block text-sm font-medium text-slate-700">
          New draft name
        </label>
        <input
          id="dup-title"
          type="text"
          value={title}
          autoFocus
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !busy) submit();
          }}
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-kyck-500 focus:outline-none focus:ring-1 focus:ring-kyck-500"
        />
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="outline" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button onClick={submit} disabled={busy || title.trim() === ''}>
            {busy ? 'Duplicating…' : 'Duplicate'}
          </Button>
        </div>
      </div>
    </div>
  );
}
